import React, { useState, createContext, useContext } from 'react';
import { cn } from '../../lib/utils';

const TabsContext = createContext();

export const Tabs = ({ defaultValue, value, onValueChange, className, children, ...props }) => {
  const [activeTab, setActiveTab] = useState(defaultValue || value);
  const currentValue = value !== undefined ? value : activeTab;
  const handleChange = (newValue) => {
    if (value === undefined) setActiveTab(newValue);
    if (onValueChange) onValueChange(newValue);
  };
  return (
    <TabsContext.Provider value={{ activeTab: currentValue, onTabChange: handleChange }}>
      <div className={className} {...props}>{children}</div>
    </TabsContext.Provider>
  );
};

export const TabsList = ({ className, ...props }) => (
  <div className={cn("inline-flex h-10 items-center justify-center rounded-md bg-slate-100 p-1 text-slate-500", className)} {...props} />
);

export const TabsTrigger = ({ value, className, children, ...props }) => {
  const { activeTab, onTabChange } = useContext(TabsContext);
  const isActive = activeTab === value;
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
        isActive ? "bg-white text-slate-800 shadow-sm" : "hover:bg-white/50",
        className
      )}
      onClick={() => onTabChange(value)}
      {...props}
    >
      {children}
    </button>
  );
};

export const TabsContent = ({ value, className, children, ...props }) => {
  const { activeTab } = useContext(TabsContext);
  if (activeTab !== value) return null;
  return (
    <div className={cn("mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500", className)} {...props}>
      {children}
    </div>
  );
};
